module.exports = {
    menu: {
        home: '首頁',
        team: '團隊',
        contact:'聯繫我們'
    },
    team:[ 
        {post:'啊啊啊',name:'嘻嘻嘻',introduce:'打发大幅度',pic:'http://img.cheerue.com/41A40353-B98F-0EF1-C0AD-EE9603D77BB7_thinkv_2017-04-28_5902c9a836289.jpg'},
        {post:'大订单',name:'发发发',introduce:'分公司分公司覆盖',pic:'http://img.cheerue.com/41A40353-B98F-0EF1-C0AD-EE9603D77BB7_thinkv_2017-04-28_5902c9a836289.jpg'},
        {post:'额鹅鹅鹅',name:'嘎嘎嘎嘎',introduce:'又要投入托付给',pic:'http://img.cheerue.com/41A40353-B98F-0EF1-C0AD-EE9603D77BB7_thinkv_2017-04-28_5902c9a836289.jpg'}
    ],
    contact: {
        company: 'CMK公司',
        phone: '電話',
        address: '地址',
        guide: '乘車線路',
        guideDetail:[
            {guide:'1.打算发的111'},
            {guide:'2.爱打飞机垃圾的说法了444'}
        ]
    }
}


// WEBPACK FOOTER //
// ./src/i18n/hk.js